module.exports = __webpack_public_path__ + "resources/sass/fn/fonts/OpenSans-Light-webfont.eot";


//////////////////
// WEBPACK FOOTER
// ./src/resources/sass/fn/fonts/OpenSans-Light-webfont.eot
// module id = 345
// module chunks = 0